var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoiceOrange = function SvgInvoiceOrange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "invoice--orange_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".invoice--orange_svg__st0{fill:#ff7101}.invoice--orange_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m52.4 57.7-2-1.9L48 58c-.2.2-.3.2-.5 0l-2.4-2.2-2.4 2.2c-.2.2-.3.2-.5 0l-2.4-2.2-2.4 2.2c-.2.2-.3.2-.5 0l-2.4-2.2-2.3 2.2c-.2.2-.3.2-.5 0l-2.4-2.2-2 1.9c-.2.2-.6.1-.6-.2V18.6c0-.3.4-.5.6-.2l2 1.9 2.4-2.2c.2-.2.3-.2.5 0l2.4 2.2L37 18c.2-.2.3-.2.5 0l2.4 2.2 2.4-2.2c.2-.2.3-.2.5 0l2.4 2.2 2.4-2.2c.2-.2.3-.2.5 0l2.4 2.2 2-1.9c.2-.2.6-.1.6.2v38.9c-.1.4-.5.5-.7.3z",
    className: "invoice--orange_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4 41.4H34.6v-1.6h10.9v1.6zM45.4 47.4H34.6v-1.6h10.9v1.6z",
    className: "invoice--orange_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.4 29.4h-11V35h11v-5.6z",
    style: {
      fill: "#0b1b34"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6 29.4c0-.4.4-.8.8-.8h11c.4 0 .8.4.8.8V35c0 .4-.4.8-.8.8h-11c-.4 0-.8-.4-.8-.8v-5.6zm1.6.8v3.9h9.4v-3.9h-9.4z",
    className: "invoice--orange_svg__st1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8 30.2 40 35l-15.8-4.8v31.5h31.5V30.2z",
    className: "invoice--orange_svg__st0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m23.4 29.2 16.6 5 16.6-5v33.4H23.4V29.2zm1.6 2.1V61h30V31.3l-15 4.6-15-4.6z",
    className: "invoice--orange_svg__st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6 56c.1-.1.3-.2.5-.2h18.5c.2 0 .4.1.5.2l6.2 5.2-1 1.2-5.9-5h-18l-6.3 5.3-1-1.2 6.5-5.5z",
    className: "invoice--orange_svg__st1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2 56.6V35h1.6v21.5h-1.6z",
    className: "invoice--orange_svg__st1"
  })));
};
export default SvgInvoiceOrange;